<template>
  <v-card v-if="screener.physical_venue">
    <!-- Seats statistics -->
    <v-card-text class="text-xs-center px-0">
      <v-layout v-if="screener" row wrap class="grey lighten-4 pa-3">
        <!-- Total -->
        <v-flex xs2>
          <div>
            <div class="greyDarken3--text display-2">
              {{
                _countTotalSeats()
              }}
            </div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.seats.statistics.total_seats") }}
            </div>
          </div>
        </v-flex>
        <!-- Available seats -->
        <v-divider vertical></v-divider>
        <v-flex v-if="seatsStatus" xs2>
          <div>
            <div class="greyDarken3--text display-2">
              {{ _countSeatsWithStatus(DEFINES.SEATS_STATUS["AVAILABLE"]) }}
            </div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.seats.statistics.available_seats") }}
            </div>
          </div>
        </v-flex>
        <!-- Screening Attended -->
        <v-divider vertical></v-divider>
        <v-flex xs2>
          <div>
            <div class="greyDarken3--text display-2">
              {{ _countSeatsWithStatus(DEFINES.SEATS_STATUS["BOOKED"]) }}
            </div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.seats.statistics.booked_seats") }}
            </div>
          </div>
        </v-flex>
        <!-- Screening Attended -->
        <v-divider vertical></v-divider>
        <v-flex xs2>
          <div>
            <div class="greyDarken3--text display-2">
              {{ _countSeatsWithStatus(DEFINES.SEATS_STATUS["LOCKED"]) }}
            </div>
            <div class="subheading grey--text text--darken-3 font-weight-thin">
              {{ $t("screener.seats.statistics.locked_seats") }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <div class="pa-3">
      <v-layout row wrap>
        <v-flex xs12 md9 class="pr-2">
          <!-- Display seats status & categories -->
          <SeatsClassifier class="mb-4"></SeatsClassifier>
          <!-- Theater Screen Effect -->
          <div class="theater-screen ma-auto py-2">
              <div class="screen-label subheading">{{$t('screener.screen.label')}}</div>
          </div>
          <!-- Seat chart -->
          <v-card class="border-grey-all my-2" flat height="70vmin" style="overflow:auto;">
            <SeatsChart
              class="pa-2"
              :config="chartConfig"
              :seats="seats"
              :reservedSeats="reservedSeats"
              :selectedSeats="selectedSeats"
              :seatsStatus="seatsStatus"
              :seatPricing="seatPricing"
              @onSeatSelected="onSeatSelected"
            ></SeatsChart>
          </v-card>
        </v-flex>
        <v-flex xs12 md3 class="pl-2">
          <SeatsCart
            :title="$t('screener.seats.cart.title')"
            :headers="cartHeaders"
            @onBook="bookingConfirmationDialog = true"
            :seats="selectedSeats"
            :discounts="ticketDiscounts"
            :instructions="cartInstructions"
            :currency="selected_company.currency"
            :consumer.sync="consumer"
            :maxSeatsToBeSelected="maxSeatsToBeSelected"
            :screenerId="screener.id"
            :having_coupon.sync="having_coupon"
            :coupon_code.sync="coupon_code"
          ></SeatsCart>
        </v-flex>
      </v-layout>
    </div>
    <!-- Seat Booking Confirmation -->
     <ConfirmationDialog
      :text="$t('screener.physical.bookings.confirm_text')"
      v-if="bookingConfirmationDialog"
      :dialog="bookingConfirmationDialog"
      @confirm="bookSeats()"
      @cancel="bookingConfirmationDialog = false"
    ></ConfirmationDialog>
  </v-card>
  <!-- <v-card v-else>
    <v-container class="pa-5" bg fill-height grid-list-md text-xs-center>
      <v-layout row wrap align-center>
        <v-flex v-if="loader">
          <v-progress-circular
            :size="70"
            color="info"
            class="overflow-hidden"
            indeterminate
          ></v-progress-circular>
        </v-flex>
        <v-flex v-else>
          <span class="grey--text">{{
            $t('screeners.save.tab.seats.not_available')
          }}</span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card> -->
</template>
<script>
import SeatsClassifier from "@/components/screener/physicalEvent/SeatsClassifier";
import SeatsCart from "@/components/screener/physicalEvent/SeatsCart";
import SeatsChart from "@/components/screener/physicalEvent/SeatsChart";
import ConfirmationDialog from '@/components/dialogBox/Confirmation';
import DEFINES from '@/defines';
import SeatSVG from "@/components/SeatSVG";
import { seatMethods } from "@/mixins/seats";
import { currencySymbol } from "@/mixins/monetization";
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import rules from "@/validation";

export default {
  name: "Seats",
  props: {
    screener: {
      type: Object,
      default: null,
    },
    allSeatsStatus: {
      type: Object,
      default: null,
    },
  },
  components: {
    SeatSVG,
    SeatsClassifier,
    SeatsCart,
    SeatsChart,
    ConfirmationDialog
  },
  data() {
    return {
      rules,
      bookingConfirmationDialog:false,
      loader: false,
      seats: {},
      selectedSeats: [],
      reservedSeats: {},
      seatsStatus: {},
      seatPricing:{},
      bookings: {},
      maxSeatsToBeSelected:0,
      chartConfig: {
        rows: null,
        cols: null,
      },
      cartHeaders: [
        {
          text: i18n.t('screener.seats.category.title'),
          align: "center",
          sortable: false,
          value: "category",
        },
        {
          text: i18n.t('screener.seats.discounts.title'),
          align: 'center',
          sortable: false,
          value: 'ticket_type'
        },
        {
          text: i18n.t('screener.seats.label.title'),
          align: "center",
          sortable: false,
          value: "label",
        },
        {
          text: i18n.t('screener.seats.price.title'),
          align: "center",
          sortable: false,
          value: "price",
        },
      ],
      seatActions: [
        {
          title: i18n.t('screener.seats.action.reset.title'),
          color: "grey",
          icon: "mdi-refresh",
          handler: this._resetSelectedSeats,
        },
        {
          title: i18n.t('screener.seats.action.lock.title'),
          color: "customPrimary",
          icon: "mdi-checkbox-marked-circle-",
          handler: this.reserveSeats,
        },
      ],
      selectedCategory: null,
      selectedSeatsPrice: null,
      consumer: {
        name:null,
        email:null
      },
      ticketDiscounts:{},
      having_coupon:false,
      coupon_code:null,
    };
  },
  watch: {
    screener: {
      deep: true,
      handler: function () {
        if (!this.screener) {
          return;
        }
        this.setSeatPricing();
        this.setTicketDiscounts();
        this.setMaxSeatsToBeSelectedCount();
      },
    },
     'screener.physical_venue': {
      deep: true,
      handler: function () {
        if (this.screener && this.screener.event_type != DEFINES.SCREENER_TYPE.VIRTUAL) {
          this.setRowCols();
          this.setSeats();
          this.setReservedSeats();
          this.getSeatsStatus();
        }
      },
    },
    seatsStatus: {
      deep: true,
      handler: function () {
        this.$emit("update:allSeatsStatus", this.seatsStatus);
      },
    },
  },
  mixins: [seatMethods, currencySymbol],
  computed: {
    ...mapGetters("company", {
      selected_company: "getSelectedCompany",
    }),
    availableSeats() {},
    cartInstructions(){
            return [
                {
                    text:this.$t("screener.seats.cart.instructions.1",{max_seats:this.maxSeatsToBeSelected}),
                }
            ]
        }
  },
  methods: {
    setRowCols() {
      this.chartConfig.rows = this.screener.physical_venue.rows;
      this.chartConfig.cols = this.screener.physical_venue.columns;
    },
    setSeats() {
      this.seats = this.screener.physical_venue.seats;
    },
    setReservedSeats() {
      this.reservedSeats = this.screener.physical_venue.not_for_sale;
    },
    setSeatPricing(){
      this.seatPricing = this.screener.physical_venue_seats_pricing;
    },
    reset() {
      this._resetSelectedSeats();
      this.dialog = false;
      this.bookingConfirmationDialog = false;
      this.consumer = {
        name:null,
        email:null
      };
    },
    _resetSelectedSeats() {
      this.selectedSeats = [];
    },
    _removeSeatFromSelected(seatId) {
      this.selectedSeats = this.selectedSeats.filter(
        (seat) => seat.id !== seatId
      );
      return this.selectedSeats;
    },
    _addSeatToSelected(seatId) {
      this.selectedSeats.push(this.getSeat(seatId));
    },
    setTicketDiscounts(){
        if(!this.screener.physical_venue_ticket_types_discount){
            return;
        }
        this.ticketDiscounts = this.screener.physical_venue_ticket_types_discount
    },
    setMaxSeatsToBeSelectedCount(){
          if(!this.screener.physical_venue_max_seats_purchase_count){
              return;
          }
          this.maxSeatsToBeSelected = this.screener.physical_venue_max_seats_purchase_count;
      },
    onSeatSelected(seatId) {

      if (this._isSeatSelected(seatId)) {
        this._removeSeatFromSelected(seatId);
        return;
      }
      // User can selected upto defined max seats only
        if(this.selectedSeats.length==this.maxSeatsToBeSelected){
            this.$store.dispatch("app/showMessage",{
                message: this.$t('screener.seats.cart.max_seat_selected.title'),
                color:"warning"
            });
            return;
        }
      this._addSeatToSelected(seatId);
    },
    async getSeatsStatus() {
      try {
        this.loader = true;
        let response = await this.$store.dispatch("screener/getSeatsStatus", {
          screener_id: this.screener.id,
        });
        this.seatsStatus = response.seats_status;
        this.loader = false;
      } catch (error) {
        this.loader = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async reserveSeats() {
      if (!this.selectedSeats.length) {
        return;
      }
      const payload = {
        screener_id: this.screener.id,
        seat_indexes: this.selectedSeats.map((seat) => seat.id),
      };
      try {
        let response = await this.$store.dispatch(
          "bookings/markSeatsLocked",
          payload
        );
        /* FIXME::Close the seat selection dialog & redirect to checkout step */
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    onCancel() {
      this.$emit("onCancel");
    },
    onConfirm() {
      this.$emit("onConfirm");
    },
    async updateSeats() {
      let selected_seats_ids = this.selectedSeats.map((seat) => seat.id);
      await this.$store
        .dispatch("screener/updatePhysicalVenueSeats", {
          screener_id: this.screener.id,
          selected_seats: selected_seats_ids,
          category: this.selectedCategory,
          price: this.selectedSeatsPrice,
        })
        .then((res) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.booking.seats.updated.success.message"),
            color: "success",
          });
          this.selectedSeats = [];
           this.$emit("onSeatsUpdate");
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    _countSeatsWithStatus(status) {
      return Object.keys(this.seatsStatus).reduce((count, key) => {
        if (this.seatsStatus[key]["status"] == status && this.seats[key].is_accessible) {
          return count += 1;
        }
        return count;
      },0);
    },

    _countTotalSeats(){
      return Object.keys(this.seats).reduce((count, key) => {
        return ( this.seats[key].is_accessible ? count +=1 : count )
      }, 0);
    },

    selectAllSeats() {
      return Object.values(this.screener.physical_venue.seats).forEach(value => {
        this.selectedSeats.push(value);
      })
    },
    /* Removes selected seats if any has been locked by others */
    _removeSelectedSeatsIfLocked(){
      let _this = this;
      this.selectedSeats.forEach((seat)=>{
          /* If seat status is not availble, then remove from selected seats */
          if(_this._seatStatus(seat.id) >= _this.DEFINES.SEATS_STATUS.LOCKED)
          {
              _this._removeSeatFromSelected(seat.id);
          }
      });
    },

    async bookSeats(){
      try{
        let ticket_types_discount={};
            this.selectedSeats.forEach (function (seat) {
                ticket_types_discount[seat.id] = seat.ticket_type;
            });
        await this.$store
          .dispatch("booking/bookSeats", {
            screener_id: this.screener.id,
            seat_indexes:this.selectedSeats.map((seat) => seat.id),
            email:this.consumer.email,
            name:this.consumer.name,
            company_id:this.screener.company_id,
            coupon_code:this.having_coupon? this.coupon_code: null,
            ticket_types_discount: ticket_types_discount
          })
          this.reset();
          this.$emit('goToPhysicalVenueStep','bookings');

          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.booking.seats.booked.success.message"),
            color: "success",
          });
      }catch(error) {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
      }finally{
          this.bookingConfirmationDialog = false;
          await this.getSeatsStatus();
          this._removeSelectedSeatsIfLocked();
      }
    }
  },
};
</script>
<style scoped>
.theater-screen {
  border-top: 4em solid rgba(0, 0, 0, 0.1);
  border-left: 3em solid transparent;
  border-right: 3em solid transparent;
  height: 0;
  width: 45%;
  text-align: center;
}
.screen-label{
    position: relative;
    top: -48px;
    color: rgba(0,0,0,0.6);
}
</style>
